import { render, staticRenderFns } from "./ElementPointChiefTableColumn.vue?vue&type=template&id=2201bb0f&scoped=true"
import script from "./ElementPointChiefTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementPointChiefTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementPointChiefTableColumn.vue?vue&type=style&index=0&id=2201bb0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2201bb0f",
  null
  
)

export default component.exports